import React, { Fragment } from 'react';

import useGroupCompetitorListAdd from './UseGroupCompetitorListAdd';

import CompetitorListAttributesForm from '../../components/forms/CompetitorListAttributesForm';

import GroupInfoForm from '@usas/ui-web/components/forms/groups/GroupInfoForm';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GroupCompetitorListAdd = () => {
  const {
    isLoading,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onBackClicked,
    orgUnitId
  } = useGroupCompetitorListAdd();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Add {formState.groupTypeName} Group</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <GroupInfoForm
          formState={formState}
          errorState={errorState}
          onFormValueChanged={onFormValueChanged}
          orgUnitId={orgUnitId}
          attributeForm={
            <CompetitorListAttributesForm
              formState={formState}
              errorState={errorState}
              onFormValueChanged={onFormValueChanged} />
          } />
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Continue</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
            {errorState && errorState.errorOnSubmitAction
              && <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction}</p>
            }
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default GroupCompetitorListAdd;